import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset } from '@fortawesome/free-solid-svg-icons';
import {Button, Modal} from "react-bootstrap";

interface ContactDialogProps {
    setContact: (bool: boolean) => void;
    contact: boolean;
}

/**
 * Component which is a dialog with contact options
 * @param {ContactDialogProps} props - The props that the ContactDialog component accepts.
 * @param {boolean} props.contact - Boolean which controls the visibility of the dialog
 * @param {Function} props.setContact - Function to set the visibility of the dialog
 * @constructor
 */
const ContactDialog = (props: ContactDialogProps) => {
    const {contact, setContact} = props;
    const close = () => setContact(false);

    return <Modal show={contact} onHide={close}>
        <Modal.Header closeButton>
            <Modal.Title><FontAwesomeIcon icon={faHeadset} /> Contacteer ons</Modal.Title>
        </Modal.Header>
        <Modal.Body>Hier komen contactmogelijkheden...</Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={close}>
                Sluiten
            </Button>
        </Modal.Footer>
    </Modal>;
}
export default ContactDialog;